export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-20 md:py-28 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-100 mb-6">
          投稿与联系
        </h2>
        <div className="w-16 h-1 bg-accent-500 mx-auto mb-8 rounded-full"></div>
        <p className="text-foreground-300 text-sm md:text-base mb-10 leading-relaxed">
          你有猛料想曝光？掌握独家黑料内幕？爆料专区提供完全匿名的投稿通道，
          所有线索均经过严格交叉验证后发布，绝不透露爆料人任何信息。
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-background-100 rounded-lg p-6 border border-background-200/60">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-mail-line text-3xl text-primary-500"></i>
            </div>
            <h3 className="font-heading text-foreground-200 text-base mb-2">匿名投稿</h3>
            <p className="text-foreground-500 text-xs leading-relaxed">
              发送爆料线索至投稿邮箱，全程加密保护
            </p>
            <span className="inline-block mt-3 text-primary-400 text-xs font-mono">
              tips@baoliao.live
            </span>
          </div>
          <div className="bg-background-100 rounded-lg p-6 border border-background-200/60">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-message-2-line text-3xl text-accent-500"></i>
            </div>
            <h3 className="font-heading text-foreground-200 text-base mb-2">商务合作</h3>
            <p className="text-foreground-500 text-xs leading-relaxed">
              广告投放、内容合作与品牌联名
            </p>
            <span className="inline-block mt-3 text-accent-400 text-xs font-mono">
              biz@baoliao.live
            </span>
          </div>
          <div className="bg-background-100 rounded-lg p-6 border border-background-200/60">
            <div className="w-12 h-12 flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-user-line text-3xl text-secondary-400"></i>
            </div>
            <h3 className="font-heading text-foreground-200 text-base mb-2">侵权申诉</h3>
            <p className="text-foreground-500 text-xs leading-relaxed">
              如内容涉及不实信息，请通过申诉通道联系
            </p>
            <span className="inline-block mt-3 text-secondary-400 text-xs font-mono">
              legal@baoliao.live
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}